export const getRandomThing = <T>(
  items: { value: T; probability: number }[]
): T => {
  const random = Math.floor(Math.random() * 100);
  let cumulativeProbability = 0;

  for (const item of items) {
    cumulativeProbability += item.probability;
    if (random < cumulativeProbability) {
      return item.value;
    }
  }

  // Fallback (should never happen if probabilities are correct)
  return items[items.length - 1].value;
};
